import { rei } from "@/services/api"

class EProtocoloService {
  static obterNotificacoes (payload) {
    return rei.post(`e-protocolo/obter-notificacoes`, {payload})
  }

  static verDetalhes (hash) {
    return rei.post(`e-protocolo/ver-detalhes`, {hash})
  }
  
  static getPdfById (id) {
    return rei.get(`e-protocolo/buscar-pdf/${id}`, { responseType: 'blob'})
  }

  static buscarPendencias (payload) {
    return rei.post(`e-protocolo/filtrar-notificacoes`, payload)
  }

  static getArquivoEstruturado (hash) {
    return rei.get(`e-protocolo/buscar-arquivo-estruturado/${hash}`)
  }
  
  static cumprirRequerimento (hash, payload, headers) {
    return rei.post(`e-protocolo/cumprir-requerimento/${hash}`, payload, { headers })
  }
  
 static vincularRegistroId (hash, registroId) {
  return rei.post('e-protocolo/vincular-registro-id', { hash, registroId })
 }

 static obterProtocolo (registroId) {
  return rei.get('e-protocolo/obter-protocolo', { params: { registroId }})
 }
}

export default EProtocoloService